<script lang="ts">
  import { Button } from "@/components/ui/button"
  import * as Dialog from "@/components/ui/dialog"
  import type { User } from "@/types"

  interface Props {
    open?: boolean
    completedFilters: Array<"true" | "false">
    approvedFilters: Array<"true" | "false">
    paidFilters: Array<"true" | "false">
    expiredFilters: Array<"true" | "false">
    userFilters: number[]
    users: User[]
    onCompletedChange: (filters: Array<"true" | "false">) => void
    onApprovedChange: (filters: Array<"true" | "false">) => void
    onPaidChange: (filters: Array<"true" | "false">) => void
    onExpiredChange: (filters: Array<"true" | "false">) => void
    onUserChange: (filters: number[]) => void
    onClose: () => void
  }

  let {
    open = $bindable(false),
    completedFilters = [],
    approvedFilters = [],
    paidFilters = [],
    expiredFilters = [],
    userFilters = [],
    users = [],
    onCompletedChange,
    onApprovedChange,
    onPaidChange,
    onExpiredChange,
    onUserChange,
    onClose,
  }: Props = $props()
</script>

<Dialog.Root bind:open>
  <Dialog.Content class="sm:max-w-md">
    <Dialog.Header>
      <Dialog.Title>Filter Task Instances</Dialog.Title>
    </Dialog.Header>
    <div class="space-y-6 py-4">
      <div>
        <h3 class="text-sm font-medium mb-3">Completed</h3>
        <div class="flex gap-2">
          <button
            type="button"
            onclick={() => {
              if (completedFilters.includes("true")) {
                onCompletedChange(completedFilters.filter((f) => f !== "true"))
              } else {
                onCompletedChange([...completedFilters, "true"])
              }
            }}
            class="px-3 py-1.5 text-sm rounded-full border transition-colors {completedFilters.includes("true")
              ? "bg-primary text-primary-foreground border-primary"
              : "bg-background text-foreground border-input hover:bg-accent hover:text-accent-foreground"}"
          >
            Yes
          </button>
          <button
            type="button"
            onclick={() => {
              if (completedFilters.includes("false")) {
                onCompletedChange(completedFilters.filter((f) => f !== "false"))
              } else {
                onCompletedChange([...completedFilters, "false"])
              }
            }}
            class="px-3 py-1.5 text-sm rounded-full border transition-colors {completedFilters.includes("false")
              ? "bg-primary text-primary-foreground border-primary"
              : "bg-background text-foreground border-input hover:bg-accent hover:text-accent-foreground"}"
          >
            No
          </button>
        </div>
      </div>
      <div>
        <h3 class="text-sm font-medium mb-3">Approved</h3>
        <div class="flex gap-2">
          <button
            type="button"
            onclick={() => {
              if (approvedFilters.includes("true")) {
                onApprovedChange(approvedFilters.filter((f) => f !== "true"))
              } else {
                onApprovedChange([...approvedFilters, "true"])
              }
            }}
            class="px-3 py-1.5 text-sm rounded-full border transition-colors {approvedFilters.includes("true")
              ? "bg-primary text-primary-foreground border-primary"
              : "bg-background text-foreground border-input hover:bg-accent hover:text-accent-foreground"}"
          >
            Yes
          </button>
          <button
            type="button"
            onclick={() => {
              if (approvedFilters.includes("false")) {
                onApprovedChange(approvedFilters.filter((f) => f !== "false"))
              } else {
                onApprovedChange([...approvedFilters, "false"])
              }
            }}
            class="px-3 py-1.5 text-sm rounded-full border transition-colors {approvedFilters.includes("false")
              ? "bg-primary text-primary-foreground border-primary"
              : "bg-background text-foreground border-input hover:bg-accent hover:text-accent-foreground"}"
          >
            No
          </button>
        </div>
      </div>
      <div>
        <h3 class="text-sm font-medium mb-3">Paid</h3>
        <div class="flex gap-2">
          <button
            type="button"
            onclick={() => {
              if (paidFilters.includes("true")) {
                onPaidChange(paidFilters.filter((f) => f !== "true"))
              } else {
                onPaidChange([...paidFilters, "true"])
              }
            }}
            class="px-3 py-1.5 text-sm rounded-full border transition-colors {paidFilters.includes("true")
              ? "bg-primary text-primary-foreground border-primary"
              : "bg-background text-foreground border-input hover:bg-accent hover:text-accent-foreground"}"
          >
            Yes
          </button>
          <button
            type="button"
            onclick={() => {
              if (paidFilters.includes("false")) {
                onPaidChange(paidFilters.filter((f) => f !== "false"))
              } else {
                onPaidChange([...paidFilters, "false"])
              }
            }}
            class="px-3 py-1.5 text-sm rounded-full border transition-colors {paidFilters.includes("false")
              ? "bg-primary text-primary-foreground border-primary"
              : "bg-background text-foreground border-input hover:bg-accent hover:text-accent-foreground"}"
          >
            No
          </button>
        </div>
      </div>
      <div>
        <h3 class="text-sm font-medium mb-3">Expired</h3>
        <div class="flex gap-2">
          <button
            type="button"
            onclick={() => {
              if (expiredFilters.includes("true")) {
                onExpiredChange(expiredFilters.filter((f) => f !== "true"))
              } else {
                onExpiredChange([...expiredFilters, "true"])
              }
            }}
            class="px-3 py-1.5 text-sm rounded-full border transition-colors {expiredFilters.includes("true")
              ? "bg-primary text-primary-foreground border-primary"
              : "bg-background text-foreground border-input hover:bg-accent hover:text-accent-foreground"}"
          >
            Yes
          </button>
          <button
            type="button"
            onclick={() => {
              if (expiredFilters.includes("false")) {
                onExpiredChange(expiredFilters.filter((f) => f !== "false"))
              } else {
                onExpiredChange([...expiredFilters, "false"])
              }
            }}
            class="px-3 py-1.5 text-sm rounded-full border transition-colors {expiredFilters.includes("false")
              ? "bg-primary text-primary-foreground border-primary"
              : "bg-background text-foreground border-input hover:bg-accent hover:text-accent-foreground"}"
          >
            No
          </button>
        </div>
      </div>
      {#if users.length > 0}
        <div>
          <h3 class="text-sm font-medium mb-3">User</h3>
          <div class="flex flex-wrap gap-2">
            {#each users as user (user.id)}
              <button
                type="button"
                onclick={() => {
                  if (userFilters.includes(user.id)) {
                    onUserChange(userFilters.filter((id) => id !== user.id))
                  } else {
                    onUserChange([...userFilters, user.id])
                  }
                }}
                class="px-3 py-1.5 text-sm rounded-full border transition-colors {userFilters.includes(user.id)
                  ? "bg-primary text-primary-foreground border-primary"
                  : "bg-background text-foreground border-input hover:bg-accent hover:text-accent-foreground"}"
              >
                {user.name}
              </button>
            {/each}
          </div>
        </div>
      {/if}
    </div>
    <Dialog.Footer>
      <Button variant="outline" onclick={onClose}>Close</Button>
    </Dialog.Footer>
  </Dialog.Content>
</Dialog.Root>
